import React, {useEffect, useState} from "react";
import classNames from "classnames";

export function OrderForm({form, order, total}) {
    let [phone, setPhone] = useState("");
    let [phoneError, setPhoneError] = useState(false);
    let [name, setName] = useState("");
    let [comment, setComment] = useState("");
    let [agree, setAgree] = useState(true);
    let [orderNumber, setOrderNumber] = useState(null);
    let [captchaResponse, setCaptchaResponse] = useState(null);
    let [isLoading, setLoading] = useState(false);

    const getReCaptchaResponse = () => {
        let $el = document.querySelector('.g-recaptcha-response');
        return $el ? $el.value : null;
    };

    const condense = (value) => {
        let exclude = "()-";
        let filter = new RegExp("["+exclude.split("").map(i => `\\${i}`).join("")+"]", "ig");
        return value.replace(filter, "").split(" ").join("");
    };

    const onPhoneChange = () => {
        setPhoneError(!/^\+?[\d\s\-()]{7,25}$/.test(phone));
    };

    /*useEffect(() => {
        let timer = setInterval(() => {
            let v = getReCaptchaResponse();
            setCaptchaResponse(v);
        }, 100);
        return () => clearInterval(timer);
    }, [captchaResponse, setCaptchaResponse]);*/

    const onSend = () => {
        let formData = {
            phone: condense(phone),
            name: name,
            comment: `Заказ: ${order.join(", ")};\nСтоимость: ${total};\nКомментарий: ${comment}`,
            formtype: 'callback',
            //'g-recaptcha-response': captchaResponse
        };

        setLoading(true);

        fetch('/api/callback', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.orderID) {
                    if (typeof ym === "function") {
                        //eslint-disable-next-line
                        ym(form.ymCounter,'reachGoal','CALLBACK_SUCCESS', {
                            order_price: total,
                            currency: "RUB"
                        });
                    }
                    if (typeof ga === "function") {
                        //eslint-disable-next-line
                        ga('gtm2.send', 'event', {
                            eventCategory: 'Order',
                            eventAction: 'Submit',
                            eventLabel: 'Callback Form',
                            eventValue: total
                        });
                    }

                    //eslint-disable-next-line
                    if (typeof dataLayer === "object" && dataLayer.push) {
                        //eslint-disable-next-line
                        dataLayer.push({event:'order',order_id: data.orderID})
                    }

                    setOrderNumber(data.orderID);
                }
            });
    }

    return (<div className="callback-form is-centered">
        {orderNumber ? <React.Fragment>
            <div className="modal-card-head">
                <p className="modal-card-title">Заявка на обратный звонок получена</p>
            </div>
            <section className="modal-card-body">
                <div className="container has-text-centered">
                    <h1 className="title is-1">№<strong>{orderNumber}</strong></h1>
                    <p>Спасибо! Мы свяжемся с вами в ближайшее время.</p>
                    <br/>
                    <p>Также вы можете позвонить нам по телефону <a href={`tel:+${condense(form.phone)}`}>{form.phone}</a> и договориться о встрече по адресу <a data-fancybox data-type="iframe" href={form.addressLink}>{form.address}</a>.
                        Ждем вас в гости в нашем шоу-руме!</p>
                </div>
            </section>
        </React.Fragment> : <React.Fragment>
            <div className="modal-card-head">
                <p className="modal-card-title">Оставьте заявку на расчет заполнив форму ниже и мы свяжемся с вами в ближайшее
                    время!</p>
            </div>
            <section className="modal-card-body">
                <form name="callback" method="post">
                    <div className="field">
                        <p className="control is-expanded">
                            <input
                                className="input is-large is-primary"
                                type="text"
                                name="phone"
                                placeholder="ТЕЛЕФОН"
                                value={phone}
                                onChange={e => setPhone(e.target.value)}
                                onBlur={onPhoneChange}
                            />
                        </p>
                        {phoneError ? <p className="help is-danger">Укажите корректный номер телефона вида +7 000
                            000-00-00</p> : null}
                    </div>

                    <div className="field">
                        <p className="control is-expanded">
                            <input
                                className="input is-large"
                                type="text"
                                name="name"
                                placeholder="ИМЯ"
                                value={name}
                                onChange={e => setName(e.target.value)}
                            />
                        </p>
                    </div>

                    <div className="field">
                        <div className="control">
              <textarea
                  className="textarea"
                  name="comment"
                  placeholder="КОММЕНТАРИЙ"
                  value={comment}
                  onChange={e => setComment(e.target.value)}
              />
                        </div>
                    </div>

                    <div className="field is-horizontal order-agreement">
                        <div className="field-body">
                            <div className="field is-expanded">
                                <div className="field">
                                    <div className="control">
                                        <label className="checkbox">
                                            <input
                                                type="checkbox"
                                                name="agree"
                                                checked={agree}
                                                onChange={e => setAgree(e.target.checked)}
                                            />
                                            Согласен (-на) на обработку моих персональных данных
                                        </label>
                                    </div>
                                </div>
                                <p className="help">Нажимая кнопку «Отправить», я даю свое согласие на обработку моих персональных данных,
                                    в соответствии с Федеральным законом от 27.07.2006 года №152-ФЗ «О персональных данных», на условиях и
                                    для целей, определенных в <a target="_blank" href="/privacy">Согласии на
                                        обработку персональных данных</a>.</p>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
            <div className="modal-card-foot">
              <span className="total-price">
                  {/*<div className="g-recaptcha" data-sitekey={form.captchaPublic}></div>*/}
              </span>
                <div className="buttons">
                    <button
                        disabled={phoneError || !agree || !phone || !name || isLoading}
                        className={classNames("button is-large is-primary", {
                            "is-loading": isLoading
                        })}
                        onClick={onSend}
                    >ОТПРАВИТЬ</button>
                </div>
            </div>
        </React.Fragment>}
    </div>);
}